import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WarningFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 3.16L21.4 19.44H2.6L12 3.16ZM11.2 14H12.8V9.8H11.2V14ZM12 17.2C12.58 17.2 13.06 16.72 13.06 16.14C13.06 15.56 12.58 15.08 12 15.08C11.42 15.08 10.94 15.56 10.94 16.14C10.94 16.72 11.42 17.2 12 17.2Z" />
    </SvgIcon>
  );
});
